import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '@ux/button';
import CloseIcon from '@ux/icon/x';

import shapes from './shapes';
import NotificationsEmpty from './list-empty';
import NotificationListItem from './list-item';

/**
 * Renders Notification list-item information or list-empty error.
 *
 * @class NotificationList
 * @public
 *
 * @returns {React.ReactElement} Notification component
 */

class NotificationList extends Component {
  render() {
    const { notifications, sso, messages, closeList, error } = this.props;

    function stopPropagation(e) {
      e.stopPropagation();
    }

    const classes = 'notifications-list dropdown-menu';

    return (
      <div className={ classes } onClick={ stopPropagation }>
        <Button
          aria-label={ messages.closeText }
          className='notifications-close'
          design='stateless'
          icon={ <CloseIcon/> }
          onClick={ closeList }>
        </Button>
        <h4 className='notifications-list-header'>{ messages.headerText }</h4>
        <ul
          className='notifications-list-items'
          id='notifications-list-items'>
          { notifications && notifications.length > 0 ? (
            notifications.map((n, c) => {
              return (
                <NotificationListItem key={ c } index={ c } notification={ n } />
              );
            })
          ) : (
            <NotificationsEmpty error={ error } messages={ messages } sso={ sso } />
          )}
        </ul>
      </div>
    );
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 *
 */

NotificationList.propTypes = {
  /** Used for sign on link when there is 401 error */
  sso: shapes.sso.isRequired,
  /** Notification strings with translations */
  messages: shapes.messages.isRequired,
  /**  User notifications */
  notifications: PropTypes.arrayOf(shapes.notification),
  /** On click sets isOpen state to false */
  closeList: PropTypes.func,
  /** Provides error code */
  error: PropTypes.object
};

export default NotificationList;
